export default "__VITE_ASSET__BhBenSTZ__"